import { IsString, IsOptional, IsUrl, IsBoolean } from 'class-validator'

export class RequisitionRequestDto {
  @IsString()
  institution_id: string

  @IsString()
  @IsUrl()
  redirect: string

  @IsString()
  reference: string

  @IsString()
  @IsOptional()
  agreement?: string

  @IsString()
  @IsOptional()
  user_language?: string

  @IsString()
  @IsOptional()
  ssn?: string

  @IsBoolean()
  @IsOptional()
  account_selection?: boolean

  @IsBoolean()
  @IsOptional()
  redirect_immediate?: boolean

}